import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ForgotPassword = () => {
  // State management
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  
  // Get the resetPassword function from auth context
  const { resetPassword } = useAuth();
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Clear previous messages
      setMessage('');
      setError('');
      setLoading(true);
      
      // Request password reset email
      await resetPassword(email);
      
      // Show success message
      setMessage('Check your email inbox for further instructions');
    } catch (err) {
      // Show error message if reset fails
      setError('Failed to reset password: ' + err.message);
    } finally {
      // Reset loading state
      setLoading(false);
    }
  };
  
  return (
    <div className="max-w-md w-full mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-center text-3xl font-extrabold text-gray-900 mb-6">
        Reset your password
      </h2>
      
      {/* Show error messages if any */}
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      
      {/* Show success message when email is sent */}
      {message && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4" role="alert">
          <span className="block sm:inline">{message}</span>
        </div>
      )}
      
      {/* Password reset form */}
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email address
          </label>
          <div className="mt-1">
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        
        <div>
          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {loading ? 'Sending...' : 'Reset Password'}
          </button>
        </div>
      </form>
      
      {/* Back to login link */}
      <div className="mt-6 text-center">
        <Link to="/login" className="font-medium text-indigo-600 hover:text-indigo-500">
          Back to Sign in
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;